"use client";
import HeadingSize from "@/components/ui/HeadingSize";
import { MoveRight } from "lucide-react";
import Image from "next/image";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function DoctorsTestimonialsSectionDesktop() {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  const doctors = [
    {
      name: t("home.doctorTestimonials.drRicha.name"),
      image: "/images/Dr. Images/richa.webp",
      quote: t("home.doctorTestimonials.drRicha.quote"),
    },
    {
      name: t("home.doctorTestimonials.ektaKhurana.name"),
      title: t("home.doctorTestimonials.ektaKhurana.title"),
      image: "/images/Dr. Images/ekta-khuranna.webp",
      quote: t("home.doctorTestimonials.ektaKhurana.quote"),
    },
    {
      name: t("home.doctorTestimonials.abhinavMahajan.name"),
      title: t("home.doctorTestimonials.abhinavMahajan.title"),
      image: "/images/Dr. Images/Abhinav.webp",
      quote: t("home.doctorTestimonials.abhinavMahajan.quote"),
    },
  ];

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? doctors.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === doctors.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-16  bg-white overflow-hidden">
      <div className="mx-auto">
        <div className="text-center mb-16">
          <HeadingSize text={t("home.trustedFacesLine1")} />
          <HeadingSize text={t("home.trustedFacesLine2")} />
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 lg:justify-between lg:items-start">
            {/* Quote */}
            <div className="w-full max-w-[280px]  lg:pt-20 text-left px-2">
              <p className="text-lg md:text-xl lg:text-2xl text-[black] font-semibold">
                "{doctors[currentIndex].quote}"
              </p>
            </div>

            {/* Images */}
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 items-center lg:items-start">
              {/* Main Image */}
              <div className="relative w-[240px] sm:w-[280px] md:w-[320px] lg:w-[500px]">
                <Image
                  src={doctors[currentIndex].image}
                  alt={`Dr. ${doctors[currentIndex].name}`}
                  width={500}
                  height={600}
                  className="w-full h-auto"
                  priority
                />
              </div>

              {/* Side Images with Navigation */}
              <div className="flex flex-col gap-4 relative">
                <div className="flex gap-3 md:gap-6 lg:gap-8">
                  <Image
                    src={doctors[(currentIndex + 1) % doctors.length].image}
                    alt={`Dr. ${
                      doctors[(currentIndex + 1) % doctors.length].name
                    }`}
                    width={280}
                    height={340}
                    quality={90}
                    className="w-[100px] h-[120px] sm:w-[120px] sm:h-[140px] md:w-[160px] md:h-[200px] lg:w-[280px] lg:h-[340px] object-cover"
                  />
                  <Image
                    src={doctors[(currentIndex + 2) % doctors.length].image}
                    alt={`Dr. ${
                      doctors[(currentIndex + 2) % doctors.length].name
                    }`}
                    width={280}
                    height={340}
                    quality={90}
                    className="w-[100px] h-[120px] sm:w-[120px] sm:h-[140px] md:w-[160px] md:h-[200px] lg:w-[280px] lg:h-[340px] object-cover"
                  />
                </div>

                {/* Navigation Arrows */}
                <div className="absolute -bottom-4 left-[160px] flex justify-center lg:justify-start gap-4 mt-4 lg:mt-2 lg:ml-20">
                  <button
                    id="previous"
                    onClick={handlePrevious}
                    className="bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg border border-[#7f1d1d]"
                    aria-label="Previous"
                    data-test-id="previous-button"
                  >
                    <MoveRight className="rotate-180 text-[#7f1d1d]" />
                  </button>
                  <button
                    id="next"
                    onClick={handleNext}
                    className="bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg border border-[#7f1d1d]"
                    aria-label="Next"
                    data-test-id="next-button"
                  >
                    <MoveRight className="text-[#7f1d1d]" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
